// Mock data for Villa in Pietra landing page

export const villaImages = [
  "/villa-images/zalazak-8.jpg",
  "/villa-images/noc-1.jpg",
  "/villa-images/noc-2.jpg",
  "/villa-images/dan-3.jpg",
  "/villa-images/zalazak-2.jpg"
];

export const villaHighlights = [
  {
    title: "Private 50m² Pool & Jacuzzi",
    description: "Exclusive swimming pool and heated jacuzzi surrounded by Mediterranean garden",
    icon: "Waves"
  },
  {
    title: "4 En-Suite Bedrooms",
    description: "Each bedroom with private bathroom, antique furnishings, and modern comfort",
    icon: "BedDouble"
  },
  {
    title: "2,500m² Private Estate",
    description: "Complete privacy in peaceful hillside village, surrounded by vineyards",
    icon: "Trees"
  },
  {
    title: "Roman Villa Atmosphere",
    description: "Centuries-old antiques from Istria, Tuscany & Sicily - authentic luxury",
    icon: "Crown"
  }
];

export const amenities = {
  indoor: [
    "Fully equipped modern kitchen",
    "Open-concept living & dining",
    "Air conditioning throughout",
    "Smart TV with streaming services",
    "High-speed WiFi",
    "Washer & dryer",
    "Espresso machine",
    "Two full-size refrigerators",
    "Wine cellar access",
    "Large closets in all bedrooms"
  ],
  outdoor: [
    "50m² private swimming pool",
    "Outdoor jacuzzi",
    "Open-air lounge with fireplace",
    "Sun loungers & pool towels",
    "Covered dining terrace",
    "BBQ area",
    "Private parking (3+ cars)",
    "Garden furniture",
    "Outdoor shower",
    "Mountain & garden views"
  ]
};

export const reviews = [
  {
    name: "Ante",
    date: "January 2026",
    rating: 5,
    text: "We had a fantastic family stay at this luxury villa. The villa is spacious, beautifully designed, and immaculately clean, with high-end amenities perfect for families. Peaceful location, an ideal base for exploring Istra. We would highly recommend this villa to families looking for a luxurious and relaxing holiday and would love to return.",
    country: "Croatia"
  },
  {
    name: "Marina",
    date: "September 2025",
    rating: 5,
    text: "Stunning villa with incredible attention to detail. The antiques are breathtaking and the pool area is paradise. Host was very responsive and helpful. Perfect for a luxury getaway!",
    country: "Austria"
  },
  {
    name: "Stefan",
    date: "August 2025",
    rating: 5,
    text: "Best vacation rental we've ever stayed in. The villa exceeded all expectations - luxurious, private, and the location is perfect for exploring Istrian wineries. Will definitely return!",
    country: "Czech Republic"
  },
  {
    name: "Klaus",
    date: "July 2025",
    rating: 5,
    text: "Absolutely magnificent property! The Roman-style antiques and furnishings create such a unique atmosphere. Pool and jacuzzi were immaculate. Privacy and tranquility beyond expectations. Highly recommended!",
    country: "Germany"
  },
  {
    name: "Sophie",
    date: "June 2025",
    rating: 5,
    text: "Perfect villa for our group of 6. Every bedroom has its own bathroom which was fantastic. The outdoor space with pool is breathtaking. Close to amazing wineries and restaurants. Can't wait to come back!",
    country: "Netherlands"
  }
];

export const faqs = [
  {
    question: "Is the pool completely private?",
    answer: "Yes, absolutely! The 50m² swimming pool and jacuzzi are exclusively for villa guests. The entire 2,500m² estate is fully private and fenced, ensuring complete privacy and tranquility during your stay."
  },
  {
    question: "How many guests can the villa accommodate?",
    answer: "Villa in Pietra comfortably accommodates up to 8 guests. There are 4 spacious bedrooms, each with its own private bathroom (4.5 bathrooms total), ensuring privacy and comfort for everyone."
  },
  {
    question: "Is the villa suitable for families with children?",
    answer: "Yes! The villa is perfect for families. The private pool, large garden, and peaceful setting are ideal for children. Please note: children must be supervised around the pool area. The villa is not suitable for infants under 2 years."
  },
  {
    question: "How far is the villa from the sea and main towns?",
    answer: "Villa in Pietra is located in Bajkini, a peaceful hilltop village. The nearest beaches in Rovinj are approximately 25 minutes by car. The charming town of Motovun is 20 minutes away, and you're surrounded by renowned Istrian wineries - some within walking distance."
  },
  {
    question: "How does the booking process work?",
    answer: "Simply contact us via WhatsApp with your desired travel dates and number of guests. We'll confirm availability and send you a personalized offer. A €500 cash deposit is required upon arrival and will be returned at checkout if everything is in order."
  },
  {
    question: "What is the cancellation policy?",
    answer: "Cancellation terms depend on your specific booking. We'll provide full details when you request your personalized offer. Generally, we offer flexible terms for early cancellations and have specific policies for last-minute changes."
  }
];

export const locationInfo = {
  village: "Bajkini",
  region: "Istria, Croatia",
  description: "Nestled in the peaceful hilltop village of Bajkini, Villa in Pietra offers the perfect blend of tranquility and accessibility. Surrounded by rolling vineyards and olive groves, you're immersed in authentic Istrian countryside while being just minutes from world-class wineries and charming medieval towns.",
  nearby: [
    { name: "Renowned wineries", distance: "Walking distance" },
    { name: "Rovinj (coast)", distance: "25 min drive" },
    { name: "Motovun", distance: "20 min drive" },
    { name: "Poreč", distance: "30 min drive" },
    { name: "Grožnjan (artist village)", distance: "15 min drive" }
  ]
};

// Detailed seasonal pricing (8 seasons)
export const seasonalPricing = [
  {
    name: "Winter Low Season",
    rate: 400,
    startDate: { month: 1, day: 1 },   // Jan 1
    endDate: { month: 3, day: 31 },     // Mar 31
    color: "#4CAF50"
  },
  {
    name: "Spring Mid Season",
    rate: 440,
    startDate: { month: 4, day: 1 },    // Apr 1
    endDate: { month: 5, day: 15 },     // May 15
    color: "#8BC34A"
  },
  {
    name: "Late Spring High",
    rate: 540,
    startDate: { month: 5, day: 16 },   // May 16
    endDate: { month: 6, day: 20 },     // Jun 20
    color: "#FFC107"
  },
  {
    name: "Early Summer Peak",
    rate: 630,
    startDate: { month: 6, day: 21 },   // Jun 21
    endDate: { month: 7, day: 10 },     // Jul 10
    color: "#FF9800"
  },
  {
    name: "Mid Summer Premium",
    rate: 685,
    startDate: { month: 7, day: 11 },   // Jul 11
    endDate: { month: 7, day: 20 },     // Jul 20
    color: "#FF5722"
  },
  {
    name: "Peak Summer Ultra",
    rate: 900,
    startDate: { month: 7, day: 21 },   // Jul 21
    endDate: { month: 8, day: 25 },     // Aug 25
    color: "#D32F2F"
  },
  {
    name: "Late Summer Peak",
    rate: 630,
    startDate: { month: 8, day: 26 },   // Aug 26
    endDate: { month: 9, day: 10 },     // Sep 10
    color: "#FF9800"
  },
  {
    name: "Autumn Low Season",
    rate: 400,
    startDate: { month: 10, day: 1 },   // Oct 1
    endDate: { month: 12, day: 31 },    // Dec 31
    color: "#4CAF50"
  }
];

// Mock pricing data - for legacy components
export const mockPricing = {
  lowSeason: { rate: 400, months: [1, 2, 3, 10, 11, 12] },
  midSeason: { rate: 540, months: [4, 5, 6] },
  highSeason: { rate: 900, months: [7, 8, 9] },
  minimumStay: 5, // nights
  deposit: 500,   // euros
  cleaningFee: 300 // euros
};

// Last minute discount
export const lastMinuteDiscount = 0.10; // 10% off

// Mock unavailable dates for calendar
export const mockUnavailableDates = [
  new Date(2026, 6, 15), // July 15
  new Date(2026, 6, 16),
  new Date(2026, 6, 17),
  new Date(2026, 6, 18),
  new Date(2026, 6, 19),
  new Date(2026, 6, 20),
  new Date(2026, 6, 21),
  new Date(2026, 7, 5), // August 5
  new Date(2026, 7, 6),
  new Date(2026, 7, 7),
  new Date(2026, 7, 8),
  new Date(2026, 7, 9),
  new Date(2026, 7, 10),
  new Date(2026, 7, 11)
];

export const whatsappNumber = "+385916227421";

export const villaStats = {
  rating: 5.0,
  reviewCount: 12,
  guests: 8,
  bedrooms: 4,
  beds: 4,
  bathrooms: 4.5
};

// Gallery images - 26 official villa photos
export const galleryImages = [
  // EXTERIOR - SUNSET (7 images)
  {
    url: "/villa-images/zalazak-8.jpg",
    title: "Aerial View at Sunset",
    category: "exterior"
  },
  {
    url: "/villa-images/zalazak-2.jpg",
    title: "Villa Estate at Golden Hour",
    category: "exterior"
  },
  {
    url: "/villa-images/zalazak-5.jpg",
    title: "Pool & Garden at Sunset",
    category: "exterior"
  },
  {
    url: "/villa-images/zalazak-2-1.jpg",
    title: "Stone Facade at Dusk",
    category: "exterior"
  },
  {
    url: "/villa-images/zalazak-2-2.jpg",
    title: "Villa Terrace at Sunset",
    category: "exterior"
  },
  {
    url: "/villa-images/zalazak-2-3.jpg",
    title: "Pool Area at Golden Hour",
    category: "exterior"
  },
  {
    url: "/villa-images/zalazak-2-5.jpg",
    title: "Garden View at Dusk",
    category: "exterior"
  },

  // EXTERIOR - NIGHT (2 images)
  {
    url: "/villa-images/noc-1.jpg",
    title: "Villa at Night - Full Estate",
    category: "exterior"
  },
  {
    url: "/villa-images/noc-2.jpg",
    title: "Pool & Jacuzzi by Night",
    category: "exterior"
  },

  // EXTERIOR - DAY AERIAL (7 images)
  {
    url: "/villa-images/dan-3.jpg",
    title: "Aerial View - Villa & Pool",
    category: "exterior"
  },
  {
    url: "/villa-images/dan-4.jpg",
    title: "Drone View - Full Property",
    category: "exterior"
  },
  {
    url: "/villa-images/dan-9.jpg",
    title: "Aerial - Pool & Garden",
    category: "exterior"
  },
  {
    url: "/villa-images/dan-10.jpg",
    title: "Top-Down Pool View",
    category: "exterior"
  },
  {
    url: "/villa-images/dan-2.jpg",
    title: "Aerial - Property Overview",
    category: "exterior"
  },
  {
    url: "/villa-images/dan-6.jpg",
    title: "Aerial - Villa & Countryside",
    category: "exterior"
  },
  {
    url: "/villa-images/dan-8.jpg",
    title: "Aerial - Villa Entrance",
    category: "exterior"
  },

  // OUTDOOR - GARDEN & TERRACE (4 images)
  {
    url: "/villa-images/dan-22.jpg",
    title: "Covered Terrace & Garden",
    category: "outdoor"
  },
  {
    url: "/villa-images/dan-23.jpg",
    title: "Garden Lounge Area",
    category: "outdoor"
  },
  {
    url: "/villa-images/dan-24.jpg",
    title: "Stone Path & Garden",
    category: "outdoor"
  },
  {
    url: "/villa-images/dan-26.jpg",
    title: "Villa Garden & Playground",
    category: "outdoor"
  },

  // LIVING - INTERIOR (1 image)
  {
    url: "/villa-images/dan-17.jpg",
    title: "Living Room with Garden View",
    category: "living"
  },

  // ENTERTAINMENT & FAMILY (5 images)
  {
    url: "/villa-images/dan-16.jpg",
    title: "Game Room with Foosball Table",
    category: "entertainment"
  },
  {
    url: "/villa-images/detalji-1.jpg",
    title: "PlayStation 5",
    category: "entertainment"
  },
  {
    url: "/villa-images/detalji-3.jpg",
    title: "Board Games & Marshall Speaker",
    category: "entertainment"
  },
  {
    url: "/villa-images/detalji-4.jpg",
    title: "Baby Crib Available",
    category: "entertainment"
  },
  {
    url: "/villa-images/dan-25.jpg",
    title: "Children's Playground",
    category: "entertainment"
  },

  // LIVING ROOMS (5 images)
  {
    url: "https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/vs0pr7pv_BAJKINI%20-%201.jpg",
    title: "Open-Concept Living & Dining",
    category: "living"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/09b977l9_BAJKINI%20-%207.jpg",
    title: "Living Room with Pool View",
    category: "living"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/ilej1ph6_BAJKINI%20-%209.jpg",
    title: "Living Space with High Ceilings",
    category: "living"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/3koxyhst_BAJKINI%20-%2012.jpg",
    title: "Lounge with Outdoor View",
    category: "living"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/1775iw7i_BAJKINI%20-%2014.jpg",
    title: "Living & Kitchen Connection",
    category: "living"
  },

  // KITCHEN (3 images)
  {
    url: "https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/xyta7n31_BAJKINI%20-%205.jpg",
    title: "Modern Kitchen with Island",
    category: "kitchen"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/ec37ibcf_BAJKINI%20-%204.jpg",
    title: "Kitchen with Marble Countertops",
    category: "kitchen"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/bmh7nofa_BAJKINI%20-%2021.jpg",
    title: "Kitchen Detail with Tapestry",
    category: "kitchen"
  },

  // DINING (1 image)
  {
    url: "https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/4mwuptnf_BAJKINI%20-%206.jpg",
    title: "Elegant Dining Area",
    category: "dining"
  },

  // BEDROOMS (6 images)
  {
    url: "https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/94lxho1x_BAJKINI%20-%2031.jpg",
    title: "Bedroom with Vaulted Ceiling",
    category: "bedroom"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/jx1fub4v_BAJKINI%20-%2036.jpg",
    title: "Guest Bedroom with Workspace",
    category: "bedroom"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/wd3ldvto_BAJKINI%20-%2041.jpg",
    title: "Bedroom with Countryside View",
    category: "bedroom"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/8fmvhru6_BAJKINI%20-%2048.jpg",
    title: "Bedroom with Garden Access",
    category: "bedroom"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/uzafhx53_BAJKINI%20-%2056.jpg",
    title: "Pool-View Bedroom",
    category: "bedroom"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/t6psordo_BAJKINI%20-%2057.jpg",
    title: "Bedroom with Terrace Access",
    category: "bedroom"
  },

  // BATHROOMS (2 images)
  {
    url: "https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/ve4wjuos_BAJKINI%20-%2033.jpg",
    title: "Double Sink Bathroom",
    category: "bathroom"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/vbukihzm_BAJKINI%20-%2054.jpg",
    title: "Bathroom with Mosaic Tiles",
    category: "bathroom"
  },

  // ANTIQUES & DETAILS (1 image)
  {
    url: "https://customer-assets.emergentagent.com/job_pietra-escape/artifacts/tefq9giu_Detalji%20-%205.jpg",
    title: "Architectural Drawings & Cabinet",
    category: "antiques"
  }
];
